var _path, _path2, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57909 18.5612C4.94415 18.5612 1.99739 14.0001 1.99739 14.0001C1.99739 14.0001 4.94415 9.43896 8.57909 9.43896C12.214 9.43896 15.1608 14.0001 15.1608 14.0001C15.1608 14.0001 12.214 18.5612 8.57909 18.5612Z",
    stroke: "#E89900",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57826 11.4883C7.19299 11.4883 6.06871 12.6124 6.06871 13.9999C6.06871 15.3874 7.19299 16.5115 8.57826 16.5115C9.96464 16.5115 11.0878 15.3874 11.0878 13.9999C11.0878 12.6124 9.96464 11.4883 8.57826 11.4883ZM8.57826 13.1627C9.04002 13.1627 9.41478 13.5378 9.41478 13.9999C9.41478 14.4621 9.04002 14.8371 8.57826 14.8371C8.11762 14.8371 7.74175 14.4621 7.74175 13.9999C7.74175 13.5378 8.11762 13.1627 8.57826 13.1627Z",
    fill: "#E89900"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 26,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 26H27V2H1V26Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0117 7.30252H26.1635V2.8374H14.0117V7.30252Z",
    stroke: "#E89900",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0117 25.1629H26.1635V20.6978H14.0117V25.1629Z",
    stroke: "#E89900",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.659 11.7676H26.1636V16.2327H17.659",
    stroke: "#E89900",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.121a277294e7d9cd0d6ba65a2fd10c16.svg";
export { ForwardRef as ReactComponent };